import { AccountChangePassword, AccountKeycloak } from '@account/routes/AccountSecurity';
import { useAuth } from '@hooks/useAuth';
import { Box } from '@mui/material';

export const AccountSecurity = () => {
    //#region Data Fetching
    const { user } = useAuth();
    //#endregion

    return (
        <>
            <title>Edit your password - Victron Professional</title>
            <Box bgcolor="#fff" className="black-border" borderRadius="5px" p="24px">
                {!user?.uses_keycloak ? <AccountChangePassword /> : <AccountKeycloak />}
            </Box>
        </>
    );
};
